import { useAppSelector } from "../store/hooks";

export type FontSizeSetting = "small" | "standard" | "large" | "very-large";

export const getFontMultiplier = (setting: FontSizeSetting): number => {
  switch (setting) {
    case "small":
      return 0.875; // ~14px
    case "large":
      return 1.125; // ~18px
    case "very-large":
      return 1.25; // ~20px
    case "standard":
    default:
      return 1; // 16px
  }
};

export const scaleRemRaw = (
  remValue: number,
  setting: FontSizeSetting
): number => {
  const multiplier = getFontMultiplier(setting);
  return remValue * multiplier;
};

export const scaleRem = (
  remValue: number,
  setting: FontSizeSetting
): string => {
  return `${scaleRemRaw(remValue, setting)}rem`;
};

export const useRemScaler = () => {
  const fontSizeSetting = useAppSelector(
    (state) => state.userInfo.fontSize
  ) as FontSizeSetting;
  return (remValue: number) => scaleRem(remValue, fontSizeSetting);
};
